export enum MessageTypes {
  sidebarResize = 'sidebar-resize',
  sidebarResizeStart = 'sidebar-resize-start',
  sidebarResizeEnd = 'sidebar-resize-end',
}
